module.exports = __webpack_public_path__ + "static/media/bank.8129c343.png";